const INITIAL_STATE = {
  otpService: "",
};

const Otp = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case "SET_OTP_SERVICE":
      return {
        ...state,
        otpService: action.payload,
      };
    default:
      return state;
  }
};

export default Otp;
